<!--
  -  Filename........: Modal.vue
  -  Project.........: logistik-app
  -  @copyright......: YBM Deutschland Andy Puderbach und Stephan Wienczny GBR
  -  @version........: 1.0
  -
  -  @since..........: 23.07.20, 15:13
  -  @author.........: Robin Rick
  -
  -  @brief..........:
  -->

<template>
    <div :id="id" class="modal" :class="{show: isActive}">
        <div class="container">
            <div class="modal-content">
                <div class="modal-header">
                    <h3>{{title}}</h3>
                    <span class="close" @click="hide">&times;</span>
                </div>
                <slot v-if="isActive"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Modal",
        props: [
            'title'
        ],
        data() {
            return {
                id: null,
                isActive: false,

            }
        },
        methods: {
            show: function () {
                this.isActive = true;
            },
            hide: function () {
                this.isActive = false;
            }
        }
    }
</script>

<style scoped>
</style>